import { render } from "./DetalleContacto.vue?vue&type=template&id=5ad93859&scoped=true"
import script from "./DetalleContacto.vue?vue&type=script&lang=js"
export * from "./DetalleContacto.vue?vue&type=script&lang=js"

import "./DetalleContacto.vue?vue&type=style&index=0&id=5ad93859&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ad93859"

export default script